import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const CREATE_MODE_STORAGE_KEY = "fable-create-mode";
type CreateMode = "create" | "studio";

// Switching still works for this session when browser storage is unavailable.
let unsavedMode: CreateMode | undefined;

export function getStoredCreateMode(): CreateMode {
  if (unsavedMode) return unsavedMode;
  try {
    return window.localStorage.getItem(CREATE_MODE_STORAGE_KEY) === "studio"
      ? "studio"
      : "create";
  } catch {
    return "create";
  }
}

export function persistCreateMode(mode: CreateMode) {
  try {
    window.localStorage.setItem(CREATE_MODE_STORAGE_KEY, mode);
    unsavedMode = undefined;
  } catch {
    unsavedMode = mode;
  }
}

/** Restore only a plain Create entry, never a draft return or a deeper flow. */
export function useRestoreStudioMode(enabled: boolean) {
  const { pathname, search, hash, state } = useLocation();
  const restoreStudio =
    enabled &&
    pathname === "/create" &&
    !search &&
    !hash &&
    (!state || Object.keys(state).length === 0) &&
    getStoredCreateMode() === "studio";

  useEffect(() => {
    if (!enabled) return;
    if (pathname === "/create/gambit") persistCreateMode("studio");
    else if (pathname === "/create" && !restoreStudio)
      persistCreateMode("create");
  }, [enabled, pathname, restoreStudio]);

  return restoreStudio;
}
